import { CSSProperties } from 'react'; 
export default function ImagesList({ images = [] }) {
    if (!images.length) return <div>Нет изображений</div>;

    return (
        <div className='max-h-[50vh] tablet:max-h-[80vh] p-0 tablet:p-[20px]' style={styles.wrapper}>
            {images.map((src, index) => (
                <div key={index} style={styles.imageBlock}>
                    <img src={src} alt={`image-${index}`} style={styles.image} />
                    {index !== images.length - 1 && (
                        <div style={styles.divider} />
                    )}
                </div>
            ))}
        </div>
    );
}

const styles: Record<string, CSSProperties> = {
    wrapper: {
        overflowY: "auto",
    },
    imageBlock: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },
    image: {
        maxWidth: "100%",
        height: "auto",
        display: "block",
        borderRadius: "12px",
    },
    divider: {
        width: "60%",
        height: "1px",
        background: "#012169",
        margin: "30px 0",
        opacity: 0.2,
    },
};